<div class="row m-0">
  <div class="col-6 pl-0 field-selection m-0">
    <nb-form-field>
      <nb-select
        [disabled]="isElementDisabled"
        [ngModel]="type.value"
        (ngModelChange)="update('type', $event)"
        placeholder="Select field type"
        fullWidth
        [status]="type.untouched ? 'basic' : type.hasError ? 'danger' : 'success'"
      >
        <nb-option *ngFor="let type of types" [value]="type.id" [disabled]="!canSelectType(type.id)">
          {{ type.name }}
        </nb-option>
      </nb-select>
    </nb-form-field>
  </div>
  <div class="col-6 m-0 position-relative field-input">
    <div class="field d-flex">
      <nb-form-field>
        <mat-icon nbPrefix class="info-icon" *ngIf="isType(personaFieldTypes.INFORMATION_MESSAGE)">info</mat-icon>
        <mat-icon nbPrefix class="warn-icon" *ngIf="isType(personaFieldTypes.WARNING_MESSAGE)">warning</mat-icon>
        <mat-icon nbPrefix class="star-icon" *ngIf="isType(personaFieldTypes.STAR_RATING)">star</mat-icon>
        <input
          [ngModel]="label.value"
          (ngModelChange)="update('label', $event)"
          (focusout)="labelFocusOut($event)"
          type="text"
          [disabled]="isElementReadOnly"
          nbInput
          fullWidth
          shape="rectangle"
          placeholder="Title"
          [status]="isLabelInvalid() ? 'danger' : 'basic'"
        />
        <!-- <mat-icon
          nbSuffix
          matTooltip="This label name will appear on the registration form and will be used in the data exports. This label can be in any language."
          matTooltipPosition="above"
        >
          help_outline
        </mat-icon> -->
      </nb-form-field>
      <mat-icon class="ml-3 d-block settings-icon" (click)="showMoreActions = !showMoreActions"> settings </mat-icon>
    </div>
    <div class="options d-flex flex-column" *ngIf="showMoreActions" [@fadeInDownOnEnter] [@fadeOutUpOnLeave]>
      <nb-checkbox
        [matTooltip]="isInDubai && isDTCMRequiredField ? 'This field is required by Dubai Department of Economy & Tourism (DET)' : ''"
        *ngIf="isSettingForValue()"
        [ngModel]="requiredOnline"
        (ngModelChange)="update('isRequiredOnline', $event)"
        status="basic"
        [disabled]="disableRequiredChanges || disableRequiredOnlineChanges"
        class="pr-2 pb-2"
      >
        Required Online
      </nb-checkbox>
      <nb-checkbox
        [matTooltip]="isInDubai && isDTCMRequiredField ? 'This field is required by Dubai Department of Economy & Tourism (DET)' : ''"
        *ngIf="isSettingForValue()"
        [ngModel]="requiredOnsite"
        (ngModelChange)="update('isRequiredOnsite', $event)"
        status="basic"
        [disabled]="disableRequiredChanges"
        class="pr-2 pb-2"
      >
        Required Onsite
      </nb-checkbox>

      <nb-checkbox
        [ngModel]="disabledOnline"
        (ngModelChange)="update('isDisabledOnline', $event)"
        [disabled]="disableRequiredChanges || disableRequiredOnlineChanges"
        [matTooltip]="isInDubai && isDTCMRequiredField ? 'This field is required by Dubai Department of Economy & Tourism (DET)' : ''"
        status="basic"
        class="pr-2 pb-2"
      >
        Hide Online
      </nb-checkbox>
      <nb-checkbox
        [ngModel]="disabledOnsite"
        (ngModelChange)="update('isDisabledOnsite', $event)"
        [disabled]="disableRequiredChanges"
        [matTooltip]="isInDubai && isDTCMRequiredField ? 'This field is required by Dubai Department of Economy & Tourism (DET)' : ''"
        status="basic"
        class="pr-2 pb-2"
      >
        Hide Onsite
      </nb-checkbox>
      <div class="divider" *ngIf="isSettingForValue()"></div>
      <nb-checkbox
        class="py-2"
        *ngIf="
          isSettingForValue() && group['value']['form_element_type_id'] !== personaFieldTypes.CHECKBOX && group['value']['form_element_type_id'] !== personaFieldTypes.STAR_RATING
        "
        [ngModel]="isUnique.value"
        (ngModelChange)="update('isUnique', $event)"
        status="basic"
        [disabled]="disableUniqueChanges"
      >
        Unique
      </nb-checkbox>
      <nb-checkbox class="py-2" [ngModel]="readonly" (ngModelChange)="update('isReadOnly', $event)" status="basic"> Read Only </nb-checkbox>

      <div class="divider" *ngIf="showLineSeparatorFontSizeSettings()"></div>

      <div *ngIf="showLineSeparatorFontSizeSettings()" class="line-separator-text-size py-2">
        <span class="d-block pb-2">Font size</span>
        <nb-radio-group [ngModel]="textSize" (ngModelChange)="update('textSize', $event)" name="line-separator-text-size-{{ elementIndex }}">
          <nb-radio *ngFor="let size of lineSeparatorTextSizes" [value]="size" class="pr-3 text-capitalize">{{ size }}</nb-radio>
        </nb-radio-group>
      </div>

      <div class="divider" *ngIf="authService.isAdmin"></div>

      <!-- Display If option -->
      <div
        *ngIf="!isType(personaFieldTypes.LINE_SEPARATOR) && authService.isAdmin"
        class="condition-option d-flex align-items-center justify-content-between py-2"
        [ngClass]="{ active: hasDisplayIfCondition }"
        [matTooltip]="isDTCMRequiredField ? 'This field is required by Dubai Department of Economy & Tourism (DET)' : ''"
        (click)="!isDTCMRequiredField && openConditionModal('displayIf')"
      >
        <nb-checkbox
          [ngModel]="hasDisplayIfCondition"
          (ngModelChange)="toggleCondition('displayIf', $event); $event.stopPropagation()"
          [disabled]="isDTCMRequiredField"
          status="basic"
          (click)="$event.stopPropagation()"
        >
          Display If
        </nb-checkbox>
        <mat-icon *ngIf="hasDisplayIfCondition" class="ml-auto condition-indicator">tune</mat-icon>
      </div>

      <!-- Required If option -->
      <div
        *ngIf="
          !isType(personaFieldTypes.LINE_SEPARATOR) && !isType(personaFieldTypes.INFORMATION_MESSAGE) && !isType(personaFieldTypes.WARNING_MESSAGE) && authService.isAdmin
        "
        class="condition-option d-flex align-items-center justify-content-between py-2"
        [ngClass]="{ active: hasRequiredIfCondition }"
        [matTooltip]="isDTCMRequiredField ? 'This field is required by Dubai Department of Economy & Tourism (DET)' : ''"
        (click)="!isDTCMRequiredField && openConditionModal('requiredIf')"
      >
        <nb-checkbox
          [ngModel]="hasRequiredIfCondition"
          (ngModelChange)="toggleCondition('requiredIf', $event); $event.stopPropagation()"
          [disabled]="isDTCMRequiredField"
          status="basic"
          (click)="$event.stopPropagation()"
        >
          Required If
        </nb-checkbox>
        <mat-icon *ngIf="hasRequiredIfCondition" class="ml-auto condition-indicator">tune</mat-icon>
      </div>

      <div class="divider"></div>
      <nb-checkbox
        *ngIf="group['value']['form_element_type_id'] == personaFieldTypes.WARNING_MESSAGE"
        [ngModel]="enableConfirmation"
        (ngModelChange)="update('enableConfirmation', $event)"
        status="basic"
        class="py-2"
      >
        Allow user confirmation
      </nb-checkbox>

      <nb-checkbox
        *ngIf="group['value']['form_element_type_id'] == personaFieldTypes.RADIO"
        [ngModel]="isDropdown"
        (ngModelChange)="update('dropdown', $event)"
        status="basic"
        class="py-2"
      >
        Is Dropdown
      </nb-checkbox>
      <!-- Enable timer option for date fields -->
      <nb-checkbox
        *ngIf="group['value']['form_element_type_id'] == personaFieldTypes.DATE"
        [ngModel]="enableTimer"
        (ngModelChange)="update('enableTimer', $event)"
        status="basic"
        class="py-2"
      >
        Enable time selection
      </nb-checkbox>

      <div class="divider" *ngIf="isSettingForValue()"></div>

      <div
        [matTooltip]="
          eventLegalSetup === 'DCT'
            ? 'This field is required by Dubai Department of Culture and Tourism (DCT)'
            : eventLegalSetup === 'DTCM'
            ? 'This field is required by Abu Dhabi Department of Economy & Tourism'
            : ''
        "
        class="delete-field d-flex py-2"
        [ngClass]="{ disable: disableDeleteChanged || isDTCMRequiredField }"
        (click)="!(disableDeleteChanged || isDTCMRequiredField) ? deleteField() : ''"
        [disabled]="disableRequiredChanges"
      >
        <mat-icon class="mr-2"> delete_outline </mat-icon>
        Delete
      </div>
    </div>
  </div>
</div>

<div class="col-12 my-3" *ngIf="nameError || typeError">
  <small class="text-danger">
    {{ nameError }}
  </small>
  <small class="text-danger">{{ typeError }}</small>
</div>
<div class="col-12" *ngIf="supportsFieldsValue()">
  <ngx-personas-form-elements-values [form]="form" [elementValues]="values"></ngx-personas-form-elements-values>
</div>
